import React from "react";

//icon
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import Icon from "../../../global/icons/Icon";

//interfaces
import { ICommentButton } from "./CommentButton";


interface ICommentsButton extends ICommentButton {
    numberOfComments: number
}

const CommentsButton = ({isDisabled, ariaLabel, onButtonClick, includeText, isActive, numberOfComments, buttonText, isReply}: ICommentsButton) => {
    const text : string = isReply 
        ? numberOfComments === 1 ?  `1 reply` : `${numberOfComments} replies`
        : numberOfComments === 1 ?  `1 comment` : `${numberOfComments} comments`

    return (
        <button
            className={`social-comments-button`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            <Icon iconName={isActive ? IconLibrary.COMMENT_ACTIVE : IconLibrary.COMMENT}  sizeInPx="12"/>
            {includeText && (buttonText ?? text)}        
        </button>
    );
};

export default CommentsButton